import { useMemo } from "react";
import { useTheme } from "./useTheme";
import { loadingSpinner, loadingSpinnerLight } from "animations";

/**
 * Hook to get the appropriate loading spinner animation based on the current theme
 * @returns The loading spinner animation data for the current theme
 */
export const useLoadingSpinner = () => {
  const { effectiveTheme } = useTheme();

  const spinnerAnimation = useMemo(() => {
    return effectiveTheme === "dark" ? loadingSpinner : loadingSpinnerLight;
  }, [effectiveTheme]);

  return spinnerAnimation;
};
